module.exports = __webpack_public_path__ + "static/media/unionPay.f6d1b374.svg";